import{lowercaseSVGElements as e}from"../../svg/lowercase-elements.mjs.js";function t(t){return"string"==typeof t&&!t.includes("-")&&!!(e.indexOf(t)>-1||/[A-Z]/u.test(t))}export{t as isSVGComponent};
